import set from 'lodash/set';

export default function setValue({ object, field, value }) {
  return set(object, field, value)
}
